(async () => {
  var setInnerHTML = function(elm, html) {
    elm.appendChild(html);
    Array.from(elm.querySelectorAll("script")).forEach( oldScript => {
      const newScript = document.createElement("script");
      Array.from(oldScript.attributes)
        .forEach( attr => newScript.setAttribute(attr.name, attr.value) );
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  const baseComponent = await import(window.theme.modules.baseComponent);
  const {
    hideElement,
    showElement,
    parseHTML
  } = await import(window.theme.modules.utils);

  customElements.define('modal-close', class extends baseComponent.default  {
    render() {
        this.addEventListener('click', (e) => {
        e.preventDefault();
        this.trigger('closePopup');
      })
    }
  })

  customElements.define('modal-trigger', class extends baseComponent.default {
      render() {
      this.addEventListener('click', (e) => {
      e.preventDefault();
    console.log(e.target);
       let el = e.target.closest('modal-trigger');
console.log(el);
      if(el) {
          if(el.getAttribute('data-cart_type') == 'ajax_without_drawer' && el.getAttribute('target') == 'CART') {
            window.location.href = '/cart';
          } else {

                  this.forwardEvent('openPopup', {
          target: this.getAttribute('target'),
          url: this.getAttribute('url'),
          layout: this.getAttribute('layout'),
          hiddenClose: this.hasAttribute('hidden-close')
        })
        }
      } else {

                  this.forwardEvent('openPopup', {
          target: this.getAttribute('target'),
          url: this.getAttribute('url'),
          layout: this.getAttribute('layout'),
          hiddenClose: this.hasAttribute('hidden-close')
        })
        }
      


    });
    };
  });


  customElements.define('modal-popup', class extends baseComponent.default {
    elements = {
      content: '[data-content]',
      overlay: '[data-overlay]',
      close: '[data-close]',
      layout: '[data-layout]'
    };

    animationTimeout = 300;
    html = document.querySelector('html');
    defaultLayoutClass = 'default';

    render() {
      if(this.hasAttribute('enable-cart')) {
        this._initCart();
      }

      [ this.$overlay, this.$close ].map(this._closeOnClick.bind(this));
      this.setAttribute('style', `--transition: ${this.animationTimeout}ms;`);

      this.listenTo('openPopup', (e, data) => {

        

        this.target = data.target;
       // debugger;
        if(data.target === 'CART') {
          this.classList.add("main-cart-popup");
          this.removeAttribute("left-aligned-modal"); 
          this.classList.remove("main-newsletter-popup");
          if(!this.cartContent) return;
          this.layout = 'sidebar';
          this.$content.replaceChildren(this.cartContent);
          this._setLayout();
          this._openModal();
          return;
        }else{
         this.classList.remove("main-cart-popup"); 
        }
        if(data.target === "#main-header-mainNav"){
          this.setAttribute("left-aligned-modal","");
           this.classList.remove("main-newsletter-popup");
        }else{
          this.removeAttribute("left-aligned-modal");
        }
        
        if(data.target=== "#newsletterPopup"){
            this.classList.add("main-newsletter-popup");
            this.removeAttribute("left-aligned-modal");
            this.classList.add("main-cart-popup");
        }else{
          this.classList.remove("main-newsletter-popup");
        }
        
        
        this.triggerSectionId = e.detail.sectionId;
        this.layout = data.layout || 'default';
        this._setLayout();
        if(data.hiddenClose) {
          hideElement(this.$close);
        }
        this._openModal();
        if (data.url) {
          this.setAttribute('loading', '');
          fetch(data.url)
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const target = doc.querySelector(data.target);
              this.removeAttribute('loading');
              setInnerHTML(this.$content, target);
            
            })
            .catch(err => console.error(err))
        } else {
          this.contentWrapper = document.querySelector(data.target);
          // this.isTemplate = this.contentWrapper.content;
          this.contentWrapper.content
            ? this.$content.replaceChildren(...this.contentWrapper.content.cloneNode(true).childNodes)
            : this.$content.replaceChildren(...this.contentWrapper.childNodes)
          // if(this.isTemplate) {
          //   this.$content.appendChild(template.content.cloneNode(true));
          // } else {
          //   this.$content.appendChild(template.cloneNode(true));
          // }
          
          const customClose = document.querySelector("[data-close-popup-custom]");
          if(customClose){
            [customClose].map(this._closeOnClick.bind(this));
          }
          
        }
      }, false);
      this.on('closePopup', this._closeModal.bind(this), false);
      this.trigger('modalReady');
      window.theme.modalReady = true;
    }

    _closeOnClick(el) {
      if(el){
      el.addEventListener('click', this._closeModal.bind(this));
      }
    }

    _closeModal(event) {
      // console.log('start animation');
      //   this.setAttribute('animating', '');
      //   setTimeout(() => {
      //     this.removeAttribute('animating');
      //     console.log('end animation');
      //   }, this.animationTimeout);
      if(event.target.classList.contains("updata_btn")){
       var add_variant = async function(itemsArr){
       // var formData = {
       //      'id': variantID,
       //      'quantity': 1
       //      };
              var response = await fetch(`${Shopify.routes.root}cart/add.js`, {
              body: JSON.stringify(itemsArr),
              method: "POST",
              headers: {
                'Content-Type': 'application/json',
                "X-Requested-With": "XMLHttpRequest"
                // Needed for Shopify to check inventory
              }
            });
         
            const responseJson = await response.json();
            if (response.ok) {  
              document.querySelector("main-cart").update(function(){});
            } else {
              console.log(responseJson["description"]);
            }
      }  

        var remove_variant = async function(itemsArr){
              var response = await fetch(`${Shopify.routes.root}cart/update.js`, {
              body: JSON.stringify(itemsArr),
              method: "POST",
              headers: {
                'Content-Type': 'application/json',
                "X-Requested-With": "XMLHttpRequest"
                // Needed for Shopify to check inventory
              }
            });
         
            const responseJson = await response.json();
            if (response.ok) {  
              document.querySelector("main-cart").update(function(){
                 window.location.reload();
              });
            } else {
              console.log(responseJson["description"]);
            }
      }  
      

      if(this.querySelector(".cart-complimentary-additional-item-popup-content")){
        var inputs = this.querySelector(".cart-complimentary-additional-item-popup-content").querySelectorAll("[data-variant-id]");
        var noAddonsInput = this.querySelector(".cart-complimentary-additional-item-popup-content").querySelector("#complimentaryAddon1");
         var variantID = "";
         var itemsArr = {items:[]};
         var updatesArr = {updates:{}};
        
         var removeItems = false;
        
        inputs.forEach(function(input){
          if(input.checked){
            if(input.getAttribute("data-qty") != "1"){
            variantID = input.getAttribute("data-variant-id");         
            input.checked = false;
            var formData = {
            'id': variantID,
            'quantity': 1
            };
            itemsArr.items.push(formData);
            updatesArr.updates[variantID] = 1;
            // if(noAddonsInput){
            //   noAddonsInput.checked = true;
            // }
          }
          }else if(input.value == "No add-ons"){
            updatesArr.updates["40171000135735"] = 0;
            updatesArr.updates["40202592223287"] = 0;
          }else{
            variantID = input.getAttribute("data-variant-id");
            updatesArr.updates[variantID] = 0;
             removeItems = true;
          }
        });
       // debugger;

        if(variantID != ""){
          //debugger;
          if(removeItems){
            remove_variant(updatesArr);    
          }else{
            add_variant(itemsArr);    
          }                
         }else{
           inputs.forEach(function(input){
              if(!input.checked){
            variantID = input.getAttribute("data-variant-id");     
             updatesArr.updates[variantID] = 0; 
              }
           });
          remove_variant(updatesArr);    
         }     
      }

      }
      this.removeAttribute('opened');
      this.setAttribute('closing', '');

      setTimeout(() => {
        if(this.contentWrapper && !this.contentWrapper.content) {
          this.contentWrapper.replaceChildren(...this.$content.childNodes);
        } else {
          this.$content.replaceChildren()
        }
        // this.$layout.classList.remove(this.layout);
        this._resetLayout();
        showElement(this.$close);
        this.removeAttribute('closing');
      }, this.animationTimeout);

      
      this.html.classList.remove('overflow-hidden');
      this.trigger('popupClosed', {
        sectionId: this.triggerSectionId
      });
    }
    
    _openModal() {
      
      // setTimeout(() => { this.setAttribute('opened', ''); }, 100);

      this.setAttribute('opened', '')
      // if (this.layout) {
      //   this.classList
      // }
      // this.$layout.classList.add(this.layout);

      // this.setAttribute('opened', '');
      if(!this.classList.contains("main-newsletter-popup")){
          this.html.classList.add('overflow-hidden');
      }
    
      this.trigger('popupOpened', {
        sectionId: this.triggerSectionId
      })
    }

    _setLayout() {
      if(this.layout) {
        // this.classList.remove(`@layout:${this.defaultLayoutClass}`);
        this.classList.add(`@layout:${this.layout}`);
      }
    }

    _resetLayout() {
      if(this.layout) {
        this.classList.remove(`@layout:${this.layout}`);
        // this.classList.add(`@layout:${this.defaultLayoutClass}`);
      }
    }

    _initCart() {
      const cartURL = this.getAttribute('cart-url');
      const cartTarget = this.getAttribute('cart-target');
      if(cartURL && cartTarget) {
        const fetchCart = (callback) => {
          fetch(cartURL)
            .then(res => res.text())
            .then(html => {
              const content = parseHTML(html).querySelector(cartTarget);
              this.cartContent = content;
              document.body.appendChild(this.cartContent);
              document.body.removeChild(this.cartContent);
            })
        }
  
        fetchCart();
  
        this.on('updateCart', (e, { callback }) => {
          this.cartContent.update(callback);
        }, false)
      }
    }
  });
  

})();